const e=(e,o)=>{for(const r of o)r in e&&delete e[r]},o=o=>{const{config:r,response:s}=o;return delete o.request,r&&e(r,["headers"]),s&&e(s,["config","headers","request"]),o};export{o as axiosHideApiHeaders};
